module.exports = __webpack_public_path__ + "img/slika15.58425b1d.jpg";